<script>
import {snakeToWords} from "@/state/helpers";
import SocialNetworkImage from "@/components/socialNetworkImage";
import HotelDatePicker from "vue-hotel-datepicker";

export default {
  components: {
    SocialNetworkImage,
    HotelDatePicker
  },
  props: {
    campaignEvents: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      sortBy: 'age',
      sortDesc: false,
      fields: [
        // 'show_details',
        {key: 'influencer', sortable: true},
        {key: 'channel', sortable: true},
        {key: 'post_type', sortable: true},
        {key: 'publish_date', sortable: true},
        {key: 'price', sortable: true, thClass: 'text-right'},
      ],
      items: [],
      fromDate: null,
      toDate: null,
      startDate: null,
      endDate: null,
      hotelDateLabels: {
        night: 'day',
        nights: 'days',
        'day-names': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        'check-in': 'Start',
        'check-out': 'End',
        'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      }
    }
  },
  computed: {
    sumPrice() {
      return this.items.reduce((result, item) => {
        if (item.price) {
          result += item.price
        }
        return result;
      }, 0);
    },
    filteredItems () {
      return this.items.filter(post => {
        const publishedAt = post.publish_date;
        if (this.fromDate && this.fromDate > publishedAt) {
          return false;
        }
        if (this.toDate && this.toDate < publishedAt) {
          return false;
        }
        return true
      })
    }
  },
  created() {
    this.campaignEvents.forEach(item => {
      let postType = item.post_type ? snakeToWords(item.post_type) : '';
      if (item.giveaway) {
        postType += ` - giveaway`;
      }
      if (item.event) {
        postType += ` - event`;
      }
      this.items.push({
        isActive: false,
        giveaway: item.giveaway,
        event: item.event,
        influencer: item.username ? item.username : item.influencer_name,
        profile_picture_url: item.profile_picture_url,
        channel: item.social_network,
        post_type: postType,
        publish_date: item.publish_date ? new Date(item.publish_date) : '',
        price: item.total_gross_price,
        influencerId: item.influencer_id
      })
    });

    if (this.items.length) {
      this.startDate = this.items[0].publish_date;
      this.endDate = this.items[0].publish_date;
      this.items.forEach(post => {
        const publishedAt = post.publish_date;
        if (new Date(this.startDate).getTime() > new Date(publishedAt).getTime()) {
          this.startDate = publishedAt;
        }
        if (new Date(this.endDate).getTime() < new Date(publishedAt).getTime()) {
          this.endDate = publishedAt;
        }
      })
    }
  },
  methods: {
    updateFromDate(date) {
      this.fromDate = date;
    },
    updateToDate(date) {
      this.toDate = date
    },
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col">
        <div style="max-width: 400px">
          <HotelDatePicker
                  ref="hotelDatePicker"
                  format="DD.MM.YYYY."
                  @check-in-changed="updateFromDate"
                  @check-out-changed="updateToDate"
                  :startingDateValue="new Date(this.startDate)"
                  :endingDateValue="new Date(this.endDate)"
                  :startDate="new Date(this.startDate)"
                  required
                  :i18n="hotelDateLabels"/>
        </div>
      </div>
    </div>
    <b-table :items="filteredItems" :fields="fields" striped responsive="sm"
             :total-rows="items.length"
             :per-page="perPage"
             :current-page="currentPage"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             class="border-left border-right border-bottom"
    >

      <template #cell(show_details)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr">
          {{ row.detailsShowing ? 'Hide' : 'Show'}} Links
        </b-button>
      </template>
      <template #row-details="row">
        <b-card class="mb-0">
          <b-row class="">
            <b-col sm="3">nesto</b-col>
          </b-row>
        </b-card>
      </template>

      <template #cell(influencer)="row">
        <router-link tag="a" :to="`/client/influencers/${row.item.influencerId}`" class="has-pointer-cursor underline-on-hover text-dark">
          <img v-if="row.item.profile_picture_url" :src="`${row.item.profile_picture_url}`"  alt class="rounded-circle avatar-xs border-1"/>
          <span v-else-if="row.value" class="avatar-xs letter-in-circle border-1 d-inline-block" style="background: gray">
              {{row.value.charAt(0)}}
            </span>
          {{row.value}}
        </router-link>
      </template>

      <template #cell(channel)="row">
        <a v-if="row.item.post_links && row.item.post_links.length > 0" :href="row.item.post_links[0]" target="_blank" class="text-dark">
          <social-network-image v-if="['instagram', 'facebook', 'youtube', 'blog'].includes(row.value)" :socialNetwork="row.value" class="mr-1"></social-network-image>
          <u class="text-capitalize">{{row.value}}</u>
          <i class="ml-1 font-size-11 fas fa-external-link-alt"></i>
        </a>
        <div v-else>
          <social-network-image v-if="['instagram', 'facebook', 'youtube', 'blog'].includes(row.value)" :socialNetwork="row.value" class="mr-1"></social-network-image>
          <span class="text-capitalize">{{row.value}}</span>
        </div>

      </template>

      <template #cell(post_type)="row">
        <span class="text-capitalize">{{row.value}}</span>
      </template>

      <template #cell(publish_date)="row">
              <span v-if="row.value">
                {{row.value | serbianDateFormat}}
              </span>
        <span v-else class="text-muted">
                Not scheduled
              </span>
      </template>

      <template #cell(price)="row">
        <div v-if="row.value" class="text-right">
          &euro;{{ row.value.toLocaleString() }}
        </div>
        <div v-else class="text-right text-muted">
          N/A
        </div>
      </template>

      <template #custom-foot>
        <b-tr>
          <b-th colspan="4" class="text-right">Total (across all pages):</b-th>
          <b-th class="text-right">&euro;{{ sumPrice.toLocaleString() }}</b-th>
        </b-tr>
      </template>
    </b-table>

    <b-pagination
        v-model="currentPage"
        :total-rows="items.length"
        :per-page="perPage"
        aria-controls="my-table"
        class="justify-content-center"
    ></b-pagination>
  </div>
</template>

<style scoped>

</style>
